import { Stack } from '@mui/material';
import React from 'react';
import { ISignatureData } from '../../../redux/project/sliceProjectSidepanel';
import DateTag from '../TextBlocks/DateTag';
import SignatureStatusIcon from './SignatureStatusIcon';
import MainField from '../TextBlocks/MainField';
import { defaultBorder } from '../../../Theme';
import GroupedAvatars from '../GroupedAvatars/GroupedAvatars';

/**
 * Displays information relating to a signature on a document.
 */
export default ({ signature }: { signature: ISignatureData }) =>
    signature ? (
        <Stack direction='row' sx={{ py: 0.75, borderBottom: defaultBorder }}>
            <SignatureStatusIcon status={signature.status} tooltip tooltipPlacement='top-start' />

            <Stack sx={{ flexGrow: 4, overflow: 'hidden', px: 1 }}>
                <MainField text={signature.task} sx={{ flexGrow: 4 }} />
                <Stack
                    sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
                >
                    <GroupedAvatars data={signature.user} />
                    <DateTag date={signature.date} showTooltipWithTime={true} />
                </Stack>
            </Stack>
        </Stack>
    ) : (
        <></>
    );
